import axios from 'axios';
import store from '../store/index';
import routerMy from '../router.js'
import { Message, Loading } from 'element-ui';
import daddress from './url'

let loading
function startLoading() {
  loading = Loading.service({ lock: true, text: '加载中...', spinner: 'el-icon-loading', background: 'rgba(0,0,0,0.7)' })
}
function endLoading() { loading && loading.close() }

if (process.env.NODE_ENV == 'development') {
  axios.defaults.baseURL = daddress.ip;
} else {
  axios.defaults.baseURL = daddress.ip;
}
axios.defaults.timeout = 200000;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

axios.interceptors.request.use(config => {
  if (config.url != "/api/fun/wxuser/byId" && !config._skipGlobalLoading) startLoading();
  const token = localStorage.getItem("token");
  token && (config.headers.token = token);
  return config;
}, error => { endLoading(); return Promise.error(error) })

axios.interceptors.response.use(response => {
  if (!response.config._skipGlobalLoading) endLoading();
  if (response.config.responseType === 'blob') return response.status === 200 ? Promise.resolve(response) : Promise.reject(response);
  if (response.data.code == 401 || response.data.code == 404) {
    localStorage.removeItem('token');
    Message.error("登录已失效");
    routerMy.replace('/');
  }
  return response.status === 200 ? Promise.resolve(response) : Promise.reject(response);
}, error => {
  endLoading();
  if (error.response && error.response.status === 401) {
    localStorage.removeItem('token');
    Message.error("登录已失效");
    routerMy.replace('/');
  }
  return Promise.reject(error.response);
})

export function get(url, params, config = {}) {
  return axios.get(url, { params, ...config }).then(res => res.data).catch(err => Promise.reject(err))
}
export function post(url, params) {
  return axios.post(url, params).then(res => res.data).catch(err => Promise.reject(err))
}

// 用户认证
export const getCode = p => get('user/GenerMobileVerificationCode', p);
export const register = p => post('user/register', p);
export const joinCompany = p => post('user/joinCompany', p);
export const accountLogin = p => post('user/accountLogin', p);
export const login = p => post('user/loginOrRegByPhone', p);
export const updatePassword = p => post('user/updatePassword', p);
export const getBindPhone = p => post('user/getBindPhone', p);

// 用户信息
export const getUserById = p => get('user/byId', p);
export const getUserPoint = p => get('user/getPoint', p);
export const getPointCountView = p => post('user/getPointCountView', p);
export const getPointCountByType = pointType => get('user/getPointCountByType?pointType=' + pointType);
export const renewPoints = p => post('user/renewPoints', p);

// 企业线索
export const searchClue = p => post('clue/search', p);
export const countSearchClue = p => post('clue/countSearch', p);
export const exportDataClue = p => post('clue/exportData', p);
export const viewLpPhoneClue = p => post('clue/viewLpPhone', p);

// 企业线索 - 分片上传单个分片
export const uploadChunkClue = (chunk, chunkIndex, totalChunks, fileId) => {
  const formData = new FormData();
  formData.append('file', chunk);
  formData.append('chunkIndex', chunkIndex);
  formData.append('totalChunks', totalChunks);
  formData.append('fileId', fileId);
  return post('clue/uploadChunk', formData).catch(err => Promise.reject(err));
};

// 企业线索 - 合并分片并批量查询
export const mergeAndBatchQueryClue = (fileId, totalChunks, fileName) => {
  const formData = new FormData();
  formData.append('fileId', fileId);
  formData.append('totalChunks', totalChunks);
  formData.append('fileName', fileName);
  return axios.post('clue/mergeAndBatchQuery', formData, {
    responseType: 'blob',
    _skipGlobalLoading: true
  }).then(res => res).catch(err => Promise.reject(err));
};

// 个体户
export const searchGTH = p => post('gth/search', p);
export const countSearchGTH = p => post('gth/countSearch', p);
export const exportDataGTH = p => post('gth/exportData', p);
export const viewLpPhoneGTH = p => post('gth/viewLpPhone', p);

// 纳税A级
export const searchTaxA = p => post('taxa/search', p);
export const countSearchTaxA = p => post('taxa/countSearch', p);
export const exportDataTaxA = p => post('taxa/exportData', p);
export const viewLpPhoneTaxA = p => post('taxa/viewLpPhone', p);

// 一般纳税人
export const searchTaxpayer = p => post('taxpayer/search', p);
export const countSearchTaxpayer = p => post('taxpayer/countSearch', p);
export const exportDataTaxpayer = p => post('taxpayer/exportData', p);
export const viewLpPhoneTaxpayer = p => post('taxpayer/viewLpPhone', p);

// 个体户银联码
export const searchSelfEmployeeCode = p => post('selfEmployeeCode/search', p);
export const countSearchSelfEmployeeCode = p => post('selfEmployeeCode/countSearch', p);
export const exportDataSelfEmployeeCode = p => post('selfEmployeeCode/exportData', p);
export const viewLpPhoneSelfEmployeeCode = p => post('selfEmployeeCode/viewLpPhone', p);

// 专精特新企业
export const searchTeXinQiYe = p => post('teXinQiYe/search', p);
export const countSearchTeXinQiYe = p => post('teXinQiYe/countSearch', p);
export const exportDataTeXinQiYe = p => post('teXinQiYe/exportData', p);
export const viewLpPhoneTeXinQiYe = p => post('teXinQiYe/viewLpPhone', p);

// 中标企业
export const searchWinningCompany = p => post('winningCompany/search', p);
export const countSearchWinningCompany = p => post('winningCompany/countSearch', p);
export const exportDataWinningCompany = p => post('winningCompany/exportData', p);
export const viewLpPhoneWinningCompany = p => post('winningCompany/viewLpPhone', p);

// 外贸人群包
export const searchForeignTrade = p => post('foreignTrade/search', p);
export const countSearchForeignTrade = p => post('foreignTrade/countSearch', p);
export const exportDataForeignTrade = p => post('foreignTrade/exportData', p);
export const viewLpPhoneForeignTrade = p => post('foreignTrade/viewLpPhone', p);

// 外贸2
export const searchForeignTradeTwo = p => post('foreignTradeTwo/search', p);
export const countSearchForeignTradeTwo = p => post('foreignTradeTwo/countSearch', p);
export const viewPrivateInfoForeignTradeTwo = p => post('foreignTradeTwo/viewPrivateInfo', p);
export const checkPurchasedForeignTradeTwo = p => post('foreignTradeTwo/checkPurchased', p);

// 年报企业
export const searchAnnualCompany = p => post('annualCompany/search', p);
export const countSearchAnnualCompany = p => post('annualCompany/countSearch', p);
export const exportDataAnnualCompany = p => post('annualCompany/exportData', p);
export const viewLpPhoneAnnualCompany = p => post('annualCompany/viewLpPhone', p);

// 分片上传单个分片
export const uploadChunkAnnualCompany = (chunk, chunkIndex, totalChunks, fileId) => {
  const formData = new FormData();
  formData.append('file', chunk);
  formData.append('chunkIndex', chunkIndex);
  formData.append('totalChunks', totalChunks);
  formData.append('fileId', fileId);
  return post('annualCompany/uploadChunk', formData).catch(err => Promise.reject(err));
};

// 合并分片并补全标签
export const mergeAndFillLabelsAnnualCompany = (fileId, totalChunks, fileName) => {
  const formData = new FormData();
  formData.append('fileId', fileId);
  formData.append('totalChunks', totalChunks);
  formData.append('fileName', fileName);
  return axios.post('annualCompany/mergeAndFillLabels', formData, {
    responseType: 'blob',
    _skipGlobalLoading: true
  }).then(res => res).catch(err => Promise.reject(err));
};

// 账单
export const viewConsumeBill = p => post('accountBill/user/search', p);
export const countPurchase = p => post('accountBill/countPurchase', p);

// 积分套餐/支付
export const getPointMealAllList = p => get('meal/listAll', p);
export const wxPay = p => post('wxPay/prepayment', p);
export const wxPayQueryStatus = rechargeId => get('wxPay/queryPayStatus?rechargeId=' + rechargeId, null, { _skipGlobalLoading: true });

// 用户路由权限
export const getUserRoute = () => post('userRoute/routes');

// 资源（type拼接到URL）
export const sysResGetRes = type => get('sysRes/getRes?type=' + type);

// 字典
export const getIndustryList = () => get('sysDict/industry');
export const getRegionList = p => get('sysDict/region', p);
export const getMainProductList = p => get('sysDict/mainProduct', p);
export const getWmCountriesList = () => get('sysDict/wmCountries');
export const getWmIndustryList = () => get('sysDict/wmIndustry');
export const getWmJobTitleList = p => get('sysDict/wmJobTitle', p);
